import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'tc-room-search-results',
  templateUrl: './room-search-results.component.html'
})
export class RoomSearchResultsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
